import configureStore from 'configureStore'

const store = configureStore()
window._store = store

export default store
